<template>
  <div id="spotlight-list" class="container pb-4">
    <h2 class="section-title">{{ page_title }}</h2>
    <div class="row justify-content-center">
      <template v-for="(page,index) in pages">
        <div class="col-auto mb-4">
          <div  class="card" :key="page.sys.id + '_' + index">
            <router-link :to="'/article/' + page.sys.id">
              <div class="card-body">
                <p class="card-title">{{ page.fields.title }}</p>
                <p class="card-text">{{ page.fields.summary }}</p>
              </div>
              <div>
                <div v-if="page.fields.logo && page.fields.logo.hasOwnProperty('fields')" class="image-outer">
                  <img :src="page.fields.logo.fields.file.url" alt="article image" class="card-img-bottom image-cover">
                </div>
                <div  v-else class="placeholder-image-outer">
                  <div class="placeholder-image">
                    <svgicon id="no-image" name="no-image" width="100" height="100" :fill="false" class="placeholder-image" />
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
 export default {
   name: 'spotlight-list',
   data() {
     return {
       page_title: 'Spotlight',
       pages: [],
       getDefaultImage: this.getDefaultImage
     }
   },
   methods: {
     getArticles() {
       let query = {
         skip: 0,
         limit: 10,
         content_type: "guide",
         include: 10,
         'fields.spotlight': true
       };
       this.$contentful
           .getEntries(query)
           .then((res) => {
             console.log("got some articles for spotlight list")
             console.log(res.items)
             this.pages = res.items
           })
           .catch((error) => {
             console.error( 'ERROR: ' + error );
           })
     }
   },
   created() {
     this.getArticles()
   },
   getDefaultImage() {
     console.log("get default image")
     let query = {
       skip: 0,
       limit: 1,
       content_type: "img",
       include: 10
     };
     this.$contentful
         .getAsset(query)
         .then((res) => {
           console.log("got default image")
           console.log(res.items)
           return res.items[0].fields.url;
         })
         .catch((error) => {
           console.error( 'ERROR: ' + error );
           return null;
         })
   }
 }
</script>

<style>
 .card {
     background-color: #bbb;
     border-radius: 0;
     width: 28em;
     height: auto;
     text-align: left;
 }

 .card-body {
     font-weight: normal;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
     color: #002330;
     height: 9em;
     margin-bottom: 1em;
 }

 div.image-outer {
     overflow: hidden;

 }

 .image-cover {
     object-fit: cover;
     vertical-align: bottom;
     height: 20em;
 }

 div.placeholder-image-outer {
     height: 20em;
     position: relative;
 }

 div.placeholder-image {

     top:50%;
     bottom:50%;
     transform:translate(33%, 50%);
 }

 /* color placeholder image gray and override hover color */
 .placeholder-image path{
     color: #a39c9b !important;
     stroke: #a39c9b !important;
     fill: #a39c9b !important;
 }

 .card-title {
     font-family: 'Titillium Web', sans-serif;
     font-size: 24px;
     font-weight: 600;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
 }

 .card-text {
 }
</style>
